/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) SC Device Icon component.
 */
export const SavedMapViewsIcon = (props: IconProps) => {
  const {iconSize = IconSize.medium, iconColor} = useIconDLS(props);

  return (
    <ThemeIconProvider name='SavedMapViewsIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox={`0 0 ${iconSize} ${iconSize}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd"
          clipRule="evenodd"
          d="M24 5.4002V5.3306C24 5.30935 23.9989 5.28812 23.9967 5.267C23.9979 5.3114 24 5.35556 24 5.4002ZM17.76 2.4002H19.44V4.5602H21.6V6.2402H19.44V8.4002H17.76V6.2402H15.6V4.5602H17.76V2.4002ZM18.6 1.2002C16.2732 1.2002 14.4 3.0734 14.4 5.4002C14.4 7.727 16.2732 9.6002 18.6 9.6002C20.9268 9.6002 22.8 7.727 22.8 5.4002C22.8 3.0734 20.9268 1.2002 18.6 1.2002Z"
          fill={iconColor}/>
        <path fillRule="evenodd"
          clipRule="evenodd"
          d="M1.2 2.74039L7.746 5.78119L7.83504 21.3692L1.2 18.2862V2.74039ZM0.62064 1.20055C0.540168 1.19778 0.459961 1.21124 0.384798 1.24012C0.309636 1.269 0.241055 1.31271 0.183142 1.36865C0.125229 1.42459 0.0791684 1.49162 0.0477044 1.56574C0.0162404 1.63986 1.67598e-05 1.71955 0 1.80007L0 18.6697C1.91877e-05 18.784 0.0327178 18.896 0.0942445 18.9924C0.155771 19.0888 0.243563 19.1656 0.34728 19.2138L7.94712 22.7442C8.02805 22.7818 8.11635 22.8009 8.2056 22.8001C8.29119 22.7994 8.37564 22.7804 8.45328 22.7444L15.8004 19.3314L23.1475 22.7442C23.2389 22.7866 23.3395 22.8053 23.4401 22.7985C23.5406 22.7918 23.6379 22.7598 23.7228 22.7056C23.8077 22.6514 23.8777 22.5767 23.9261 22.4883C23.9746 22.4 24 22.3008 24 22.2001V5.40007C24.0006 6.63323 23.5769 7.82904 22.8 8.78671V21.2598L16.1573 18.1741L16.1117 10.1893C15.8594 10.0578 15.6178 9.90672 15.3893 9.73735L15.4373 18.1762L8.55504 21.3738L8.46648 5.86831L13.5425 3.51007C13.8071 2.80724 14.215 2.16713 14.7403 1.63039L8.19984 4.66879L0.85272 1.25599C0.779852 1.22216 0.700931 1.20331 0.62064 1.20055V1.20055Z"
          fill={iconColor}/>
      </svg>
    )} />
  );
};
